<template>
	<div>
		<ja-loader v-if="!items.length && useLoader" />
		<div
			v-else-if="items.length"
			class="table table--simple"
			:class="getTableClasses()"
		>
			<div class="table__row row--header">
				<div
					v-for="(header, index) in tableHeaders"
					:key="index"
					class="table__header table__cell sticky"
					:class="getStickyClasses(true, false)"
				>
					{{ $t(`${header}`) }}
				</div>
			</div>

			<div v-for="(item, index) in items" :key="index" class="table__row">
				<div
					v-for="(columnKey, key) in defaultOptions.columnKeys"
					:key="key"
					class="table__cell"
					:class="getStickyClasses(false, true)"
				>
					{{ item[columnKey] }}
				</div>
			</div>
		</div>
		<div v-else class="mt--2 mb--2 text--center">
			{{ $t('noResultsFound') }}
		</div>
	</div>
</template>

<script>
import Loader from '@ui/Loader';
export default {
	components: {
		jaLoader: Loader
	},
	props: {
		options: {
			type: Object,
			default: () => {}
		},
		items: {
			type: Array,
			default: () => []
		},
		translationPrefix: {
			type: String,
			default: ''
		},
		useLoader: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			defaultOptions: {
				colorize: true,
				stickyHeader: false,
				stickyColumn: false,
				columnKeys: ''
			},
			data: [],
			tableHeaders: []
		};
	},
	watch: {
		items() {
			this.dataAdapter();
		}
	},
	mounted() {
		this.updateOptions();
		this.dataAdapter();
	},
	methods: {
		getStickyClasses(isHeader, isColumn) {
			const { stickyHeader, stickyColumn } = this.defaultOptions;
			const classes = ['sticky'];

			if (!stickyHeader && !stickyColumn) {
				return '';
			}

			if (stickyHeader && isHeader) {
				classes.push('sticky--top');
			}

			if (stickyColumn && isColumn) {
				classes.push('sticky--left');
			}

			return classes.join(' ');
		},
		getTableClasses() {
			const classes = [];

			if (this.defaultOptions.colorize) {
				classes.push('colorize');
			}

			classes.push(`cols--${this.defaultOptions.columnKeys.length || 1}`);

			return classes.join(' ');
		},
		updateOptions() {
			this.defaultOptions = { ...this.defaultOptions, ...this.options };
		},
		dataAdapter() {
			if (!this.items) {
				return;
			}

			// TODO: Make this a bit more smart
			// allowing dot-notation
			this.tableHeaders = this.defaultOptions.columnKeys;
			if (this.translationPrefix !== '') {
				this.tableHeaders = this.tableHeaders.map(item => {
					return `${this.translationPrefix}.${item}`;
				});
			}

			return this.items;
		}
	}
};
</script>
